module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-07-0e2d73ceeebee0ddfe9fe1b06aafe67d.jpg";